import { createApp } from 'vue/dist/vue.esm-bundler.js'
{
  const appConfig = {
    compilerOptions: {
      // register any non-vue custom elements we can use inside this app
      isCustomElement: (tag) => ["g-map-2", "g-marker", "ada-toggler", "fieldgroup" ].includes(tag),
    },    
    props: [
      'el'
    ],
    data(){
      return {
        foundLocations: [],

        // localized data
        googleMapsAPIKey: '',
        presetState: '',
        originalPresetState: '',

        // app data
        searchType: 'zip', // geolocation|zip - how should the users latitude/longitude be determined? 
        zip: null,
        radius: 25,
        filters: [],
        totalResults: 0,

        // data to manage the app state
        searchIsDirty : false,
        latitude: null,
        longitude: null,
        loading: false,
      }
    },
    mounted(){
      this.googleMapsAPIKey = this.el.dataset.mapKey
      this.presetState = this.el.dataset.presetState
      this.originalPresetState = this.el.dataset.presetState
      this.sortAndFilter(false) // initial load - don't steal focus
    },
    computed: {
      currentDay() {
        // return new Date().toLocaleString('en-US', { weekday: 'long' }).toLowerCase();
      },
      activeFilterLabel() {
        return this.filters.includes('open') ? 'Open' : null
      },
      searchNearLabel() {
        if (this.searchType === 'zip' && this.zip) {
          return this.zip
        }
        if (this.searchType === 'geolocation' && this.latitude && this.longitude) {
          return 'me'
        }
        return null
      },
      statusLine() {
        const parts = []
        if (this.activeFilterLabel) {
          parts.push(`Filtering locations by ${this.activeFilterLabel}.`)
        }
        if (this.searchNearLabel) {
          parts.push(`Searching locations near ${this.searchNearLabel}.`)
        }
        parts.push(`Showing ${this.foundLocations.length} results.`)
        // parts.push(`Showing ${this.foundLocations.length} of ${this.totalResults} total results.`)
        return parts.join(' ')
      }
    },
    methods: {
      handleFormSubmission(resetFilters) {

        if(resetFilters){
          this.filters = []
        }

        if (this.searchType === 'zip' && !this.zip) {
          // no zip entered - fall back to the page's state filter (query var), if any
          this.presetState = this.originalPresetState
        } else {
          this.presetState = '' // once they search, the landing-page state filter no longer applies
        }

        if (this.searchType === 'geolocation') {
          if (this.latitude && this.longitude) {
            this.sortAndFilter()
          } else {
            this.setLatLongByNear()
          }
        } else {
          this.sortAndFilter()
        }

      },
      // sets latitude/longitude by the users geolocation, runs the search
      setLatLongByNear() {
        if (this.latitude && this.longitude) {
          return
        }
      
        this.loading = true
      
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(pos => {
            this.latitude = pos.coords.latitude
            this.longitude = pos.coords.longitude
            this.sortAndFilter() // <-- actually run the search now
          }, err => {
            this.loading = false
            this.searchType = 'zip'
            switch (err.code) {
              case err.PERMISSION_DENIED:
                alert("Location permission was denied.")
                break
              case err.POSITION_UNAVAILABLE:
                alert("Location information is unavailable.")
                break
              case err.TIMEOUT:
                alert("The request to get your location timed out.")
                break
              default:
                alert("An unknown error occurred.")
                break
            }
          })
        } else {
          this.loading = false
          this.searchType = 'zip'
          alert("Geolocation is not supported by this browser.")
        }
      },
      changeFilter(value) {
        const idx = this.filters.indexOf(value)
        if (idx > -1) {
          this.filters.splice(idx, 1)
        } else {
          this.filters.push(value)
        }
        this.sortAndFilter()
      },
      // primary ajax handler
      // returns foundLocations
      sortAndFilter(moveFocus = true){
        this.loading = true
        window.coolHelperFunctions.coolAjax({
          action: 'fetch__locations',
          zip_code: this.zip,
          latitude: this.latitude,
          longitude: this.longitude,
          radius: this.radius,
          preset_state: this.presetState,
          filters : this.filters
        }, success => {
          this.loading = false
          if(success?.success){
            this.foundLocations = success.data.posts
            this.totalResults = success.data.total
            this.searchIsDirty = true
            this.$forceUpdate()
            if (moveFocus) {
              this.$nextTick(() => {
                this.$refs.resultsStatus?.focus()
              })
            }
          } else {
            alert("Unexpected result. Please try again later.")
          }
        }, error => {
          this.loading = false
          alert("Something went wrong. Please try again later.")
        })
      },
      // reset lat/lng on search type change
      onSearchTypeChange(){
        this.zip = ''
        this.latitude = null
        this.longitude = null
        // If switching to geolocation, immediately request permission
        if (this.searchType === 'geolocation') {
          this.setLatLongByNear()
        }
      },
      changeSearchType(type) {
        if (this.searchType === type) {
          return
        }
      
        this.searchType = type
        this.onSearchTypeChange()
      },

    }
  }

  function initApp(){
    const els = document.querySelectorAll('.locations-map--app')
    if(els.length){
      els.forEach(el => {
        const app = createApp(appConfig, { el })
        app.mount(el)
      })
    }
  }

  initApp()
}